import { BuscarNotasFiscaisModel } from "../models/notasFiscais/buscarNotasFiscaisModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toastError, toastSucess } from "../util/toast";
import { setModalDeletarNotasFiscais } from "../redux/slices/notasfiscais/notasFiscaisSlice";

export const listarNotasFiscais = createAsyncThunk("/NotasFiscais/ListarNotasFiscais", async (args: BuscarNotasFiscaisModel) => {
  try {
    const data = await api.get("/NotasFiscais/ListarNotasFiscais", { params: args });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const deletarNotasFiscais = createAsyncThunk("/NotasFiscais/DeletarNotasFiscais", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/NotasFiscais/DeletarNotasFiscais", {
      params: { idPrestacaoContaConsignatario: payload.value },
    });
    toastSucess("Nota fiscal removida com sucesso");
    dispatch(setModalDeletarNotasFiscais(false));
    dispatch(setLoading(false));

    dispatch(listarNotasFiscais(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
